<template>
  <router-view v-if="!onLoadProfile"></router-view>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$moment.locale("th");
    this.getDataProfile();
  },
  data() {
    return {
      onLoadProfile: false,
    };
  },
  methods: {
    getDataProfile: function() {
      if (this.$cookies.isKey("admin-token")) {
        var admin_token = this.$cookies.get("admin-token");

        this.onLoadProfile = true;
        this.axios
          .get(`${this.$baseUrl}/user`)
          .then((res) => {
            res.detail.token = admin_token;
            this.$store.dispatch("setUserData", res.detail);
            if (this.$route.query.brandID != res.detail.brandId) {
              // window.location = `${this.$route.path}?brandID=${res.detail.brandId}`;
              this.$router.push({
                path: "/",
                query: { brandID: res.detail.brandId },
              });
              // this.$router.replace({ query: { brandID: res.detail.brandId } });
            }
            this.onLoadProfile = false;
          })
          .catch((error) => {
            console.log(error.message);
            this.onLoadProfile = false;
            window.location = "/login";
          });
      }
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
